import { appUrl } from 'utils/wrappers';

import Base from 'app/models/base';

export default Base.extend({
  urlRoot: appUrl('batches'),
  rootKey: 'batch',
});



// WEBPACK FOOTER //
// ./app/models/batch.js